import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import cc from 'classcat';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import Chat from 'modules/Chat';
import User from 'modules/User';
import Message from './Message';

const getLastMessage = (messageRefs) =>
  (messageRefs?.length > 1 && messageRefs[messageRefs.length - 1]) || null;

export const _MessageList = (props) => {
  const { messageRefs, messages, avatar, username, users, leftAt, onMessage } = props;
  const leftAtDate = new Date(leftAt);
  const lastMessageRef = getLastMessage(messageRefs);

  useEffect(() => {
    if (onMessage) onMessage();
  }, [lastMessageRef, onMessage]);

  return isEmpty(messageRefs) ? null : (
    <div id="talkArea">
      {messageRefs.map((ref) => {
        const message = messages[ref];
        if (!message) {
          return false;
        }
        const isCurrentUser = message.sentBy === username;
        const user = users[message.sentBy];
        const isMod = user && user.isModerator;
        const isVIP = user && user.isVIP;
        const asideClass = cc([
          {
            userGen: isCurrentUser,
            modGen: isMod,
            vipGen: isVIP,
            oldMessage: leftAtDate && leftAtDate >= new Date(message.sentAt),
            lastMessage: lastMessageRef === ref
          }
        ]);
        const title = cc([
          {
            'MrQ Moderator': !isCurrentUser && isMod,
            VIP: !isCurrentUser && isVIP,
            You: isCurrentUser
          }
        ]);
        const userAvatar = cc([
          {
            moderator: !(user && user.avatar) && !isCurrentUser && isMod, // moderator fallback
            [avatar]: isCurrentUser
          }
        ]);
        return (
          <Message
            className={asideClass}
            key={ref}
            title={title}
            avatar={userAvatar || (user && user.avatar)}
            username={message.sentBy}
            date={message.sentAt}
            isMod={isMod}
            isVIP={isVIP}
          >
            {message.value}
          </Message>
        );
      })}
    </div>
  );
};

_MessageList.propTypes = {
  channel: PropTypes.string,
  avatar: PropTypes.string.isRequired,
  leftAt: PropTypes.number,
  onMessage: PropTypes.func,
  username: PropTypes.string,
  users: PropTypes.object,
  messages: PropTypes.object,
  messageRefs: PropTypes.arrayOf(PropTypes.string)
};

_MessageList.defaultProps = {
  username: '',
  leftAt: null,
  channel: '',
  users: {},
  onMessage: null,
  messages: {},
  messageRefs: []
};

const mapStateToProps = (state, { channel }) => ({
  username: User.selectors.model(state).username,
  avatar: User.selectors.model(state).avatar,
  users: Chat.selectors.getUsers(state),
  leftAt: Chat.selectors.getChannelLeftAt(state, channel),
  messages: Chat.selectors.getMessages(state),
  messageRefs: Chat.selectors.getChannelMessageRefs(state, channel)
});
// messageRefs
export default connect(mapStateToProps)(
  memo(_MessageList, (prevProps, nextProps) => prevProps.messageRefs === nextProps.messageRefs)
);
